import { render, staticRenderFns } from "./Income.vue?vue&type=template&id=047566eb&scoped=true"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"
import style0 from "./Income.vue?vue&type=style&index=0&id=047566eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047566eb",
  null
  
)

export default component.exports